import { MotifTooltip, MotifIcon } from "@ey-xd/motif-react";
import { IconoirHelpCircle, IconoirInfoCircle } from "@ey-xd/motif-icon";
import "./InfoTooltip.scss";

type InfoTooltipProps = {
  description: string | JSX.Element;
  id: string;
  info?: boolean;
  size?: string;
};

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  description,
  id,
  info = false,
  size = "20",
}) => {
  return (
    <MotifTooltip
      id={`${id}-tooltip`}
      contentClassName="tooltip-content"
      placement="auto"
      hideCloseButton
      trigger={
        <MotifIcon
          className="label-info-icon-container"
          iconFunction={info ? IconoirInfoCircle : IconoirHelpCircle}
          size={size}
        />
      }
      variant="default"
    >
      <div className="label-info-icon-text">{description}</div>
    </MotifTooltip>
  );
};

export default InfoTooltip;
